/** `catalog` module DTOs keys */
export enum CatalogDtosKeysEnum {
  /** Accounting account filters query parameters */
  ACCOUNTING_ACCOUNT_FILTERS_DTO = 'catalog/accounting-account-filters.dto',
  /** Accounting account response body */
  ACCOUNTING_ACCOUNT_FIND_DTO = 'catalog/accounting-account-find.dto',
  /** Accounting accounts list API response body */
  ACCOUNTING_ACCOUNT_PAGE_DTO = 'catalog/accounting-account-page.dto',
  /** Accounting account list API query parameters */
  ACCOUNTING_ACCOUNT_QUERY_DTO = 'catalog/accounting-account-query.dto',
  /** Accounting subaccount response body */
  ACCOUNTING_SUB_ACCOUNT_FIND_DTO = 'catalog/accounting-sub-account-find.dto',
  /** Budget classification code list API base filters */
  BUDGET_CLASSIFICATION_CODE_FILTERS_DTO = 'catalog/budget-classification-code-filters.dto',
  /** Budget classification code find many API query parameters */
  BUDGET_CLASSIFICATION_CODE_FIND_MANY_QUERY_DTO = 'catalog/budget-classification-code-find-many-query.dto',
  /** Budget classification code find one API query parameters */
  BUDGET_CLASSIFICATION_CODE_FIND_ONE_QUERY_DTO = 'catalog/budget-classification-code-find-one-query.dto',
  /** Budget classification code response body */
  BUDGET_CLASSIFICATION_CODE_FIND_DTO = 'catalog/budget-classification-code-find.dto',
  /** Budget classification code create and update APIs request body */
  BUDGET_CLASSIFICATION_CODE_FORM_DTO = 'catalog/budget-classification-code-form.dto',
  /** Budget classification code page response body */
  BUDGET_CLASSIFICATION_CODE_PAGE_DTO = 'catalog/budget-classification-code-page.dto',
  /** Budget revenue admin list API base filters */
  BUDGET_REVENUE_ADMIN_FILTERS_DTO = 'catalog/budget-revenue-admin-filters.dto',
  /** Budget revenue admin find many API query parameters */
  BUDGET_REVENUE_ADMIN_FIND_MANY_QUERY_DTO = 'catalog/budget-revenue-admin-find-many-query.dto',
  /** Budget revenue admin find one API query parameters */
  BUDGET_REVENUE_ADMIN_FIND_ONE_QUERY_DTO = 'catalog/budget-revenue-admin-find-one-query.dto',
  /** Budget revenue admin response body */
  BUDGET_REVENUE_ADMIN_FIND_DTO = 'catalog/budget-revenue-admin-find.dto',
  /** Budget revenue admin create and update APIs request body */
  BUDGET_REVENUE_ADMIN_FORM_DTO = 'catalog/budget-revenue-admin-form.dto',
  /** Budget revenue admins page response body */
  BUDGET_REVENUE_ADMIN_PAGE_DTO = 'catalog/budget-revenue-admin-page.dto',
  /** Cost center filter query parameters */
  COST_CENTER_FILTERS_DTO = 'catalog/cost-center-filters.dto',
  /** Const center find one API additional options (query parameters) */
  COST_CENTER_FIND_ONE_OPTIONS_DTO = 'catalog/cost-center-find-one-options.dto',
  /** Cost center response body */
  COST_CENTER_FIND_DTO = 'catalog/cost-center-find.dto',
  /** Cost center create/update request body */
  COST_CENTER_FORM_DTO = 'catalog/cost-center-form.dto',
  /** Cost centers list page response body */
  COST_CENTER_PAGE_DTO = 'catalog/cost-center-page.dto',
  /** Cost center list API query parameters */
  COST_CENTER_QUERY_DTO = 'catalog/cost-center-query.dto',
  /** Currency find many API query parameters (settings and filters) */
  CURRENCY_FIND_MANY_QUERY_DTO = 'catalog/currency-find-many-query.dto',
  /** Currency find one API query parameters (additional options) */
  CURRENCY_FIND_ONE_QUERY_DTO = 'catalog/currency-find-one-query.dto',
  /** Currency response body */
  CURRENCY_FIND_DTO = 'catalog/currency-find.dto',
  /** Currency create and update APIs request body */
  CURRENCY_FORM_DTO = 'catalog/currency-form.dto',
  /** Currencies list API page response body */
  CURRENCY_PAGE_DTO = 'catalog/currency-page.dto',
  /** Currency rate list APIs base filters */
  CURRENCY_RATE_FILTERS_DTO = 'catalog/currency-rate-filters.dto',
  /** Currency rate find many API query parameters */
  CURRENCY_RATE_FIND_MANY_QUERY_DTO = 'catalog/currency-rate-find-many-query.dto',
  /** Currency rate find one API query parameters */
  CURRENCY_RATE_FIND_ONE_QUERY_DTO = 'catalog/currency-rate-find-one-query.dto',
  /** Currency rate response body */
  CURRENCY_RATE_FIND_DTO = 'catalog/currency-rate-find.dto',
  /** Currency rate create and update APIs request body */
  CURRENCY_RATE_FORM_DTO = 'catalog/currency-rate-form.dto',
  /** Currency rate find many API response body */
  CURRENCY_RATE_PAGE_DTO = 'catalog/currency-rate-page.dto',
  /** Currency rate single APIs URL parameters */
  CURRENCY_RATE_PARAMS_DTO = 'catalog/currency-rate-params.dto',
  /** Add user to direction API request body */
  DIRECTION_ADD_USER_FORM_DTO = 'catalog/direction-add-user-form.dto',
  /** Add user group to direction API request body */
  DIRECTION_ADD_USER_GROUP_FORM_DTO = 'catalog/direction-add-user-group-form.dto',
  /** Direction response body */
  DIRECTION_FIND_DTO = 'catalog/direction-find.dto',
  /** Direction create/update request body */
  DIRECTION_FORM_DTO = 'catalog/direction-form.dto',
  /** Directions' group create/update request body */
  DIRECTION_GROUP_FORM_DTO = 'catalog/direction-group-form.dto',
  /** Directions list and tree APIs query parameters */
  DIRECTION_QUERY_DTO = 'catalog/direction-query.dto',
  /** Directions reorder API request body */
  DIRECTIONS_REORDER_DTO = 'catalog/directions-reorder.dto',
  FILIAL_FIND_DTO = 'catalog/filial-find.dto',
  FILIAL_FORM_DTO = 'catalog/filial-form.dto',
  FILIAL_QUERY_DTO ='catalog/filial-query.dto',
  UNIT_FORM_DTO = 'catalog/unit-form.dto',
  UNIT_FIND_DTO = 'catalog/unit-find.dto',
  UNIG_FIND_QUERY_DTO = 'catalog/unit-find-query.dto',
  MASTER_MILESTONE_HISTORY_FIND_DTO = 'catalog/master-milestone-history-find.dto',
  MASTER_MILESTONE_HISTORY_PAGE_DTO = 'catalog/master-milestone-history-page.dto',
  /** Approval scheme list API query parameters */
  APPROVAL_SCHEME_QUERY_DTO = 'catalog/approval-scheme-query.dto',
  APPROVAL_SCHEME_FIND_DTO = 'catalog/approval-scheme-find.dto',
  APPROVAL_SCHEME_FORM_DTO = 'catalog/approval-scheme-form.dto',
  APPROVAL_SCHEME_HISTORY_FIND_DTO = 'catalog/approval-scheme-history-find.dto',
  APPROVAL_SCHEME_HISTORY_PAGE_DTO = 'catalog/approval-scheme-history-page.dto',
  BANK_FIND_DTO = 'catalog/bank-find.dto',
  /** Nomenclature item and group response body common fields */
  NOMENCLATURE_BASE_FIND_DTO = 'catalog/nomenclature-base-find.dto',
  /** Nomenclature item and group create and update request body common fields */
  NOMENCLATURE_BASE_FORM_DTO = 'catalog/nomenclature-base-form.dto',
  /** Nomenclature group response body */
  NOMENCLATURE_GROUP_FIND_DTO = 'catalog/nomenclature-group-find.dto',
  /** Nomenclature group create and update request body */
  NOMENCLATURE_GROUP_FORM_DTO = 'catalog/nomenclature-group-form.dto',
  /** Nomenclature item response body */
  NOMENCLATURE_ITEM_FIND_DTO = 'catalog/nomenclature-item-find.dto',
  /** Nomenclature item create and update request body */
  NOMENCLATURE_ITEM_FORM_DTO = 'catalog/nomenclature-item-form.dto',
  /** Nomenclature item list API query parameters */
  NOMENCLATURE_ITEM_QUERY_DTO = 'catalog/nomenclature-item-query.dto',
  /** Nomenclature mixed items and groups tree node response body  */
  NOMENCLATURE_TREE_FIND_DTO = 'catalog/nomenclature-tree-find.dto',
  /** Nomenclature mixed items and groups tree API query parameters */
  NOMENCLATURE_TREE_QUERY_DTO = 'catalog/nomenclature-tree-query.dto',
  /** Nomenclature group list API query parameters */
  NOMENCLATURE_GROUP_QUERY_DTO = 'catalog/nomenclature-group-query.dto',
  /** Payer status list APIs base filters */
  PAYER_STATUS_FILTERS_DTO = 'catalog/payer-status-filters.dto',
  /** Payer status find many API query parameters */
  PAYER_STATUS_FIND_MANY_QUERY_DTO = 'catalog/payer-status-find-many-query.dto',
  /** Payer status find one API additional query parameters */
  PAYER_STATUS_FIND_ONE_QUERY_DTO = 'catalog/payer-status-find-one-query.dto',
  /** Payer status response body */
  PAYER_STATUS_FIND_DTO = 'catalog/payer-status-find.dto',
  /** Payer status create and update APIs request body */
  PAYER_STATUS_FORM_DTO = 'catalog/payer-status-form.dto',
  /** Payer statuses page response body */
  PAYER_STATUS_PAGE_DTO = 'catalog/payer-status-page.dto',
  NOMENCLATURE_FIND_DTO = 'catalog/nomenclature-find.dto',
  NOMENCLATURE_FORM_DTO = 'catalog/nomenclature-form.dto',
  NOMENCLATURE_QUERY_DTO = 'catalog/nomenclature-query.dto',
  MASTER_MILESTONE_FIND_DTO = 'catalog/master-milestone-find.dto',
  MASTER_MILESTONE_FORM_DTO = 'catalog/master-milestone-form.dto',
  COPY_REFERENCE_QUERY_DTO = 'catalog/copy-reference-query.dto',
  REFERENCE_FIND_DTO = 'catalog/reference-find.dto',
  REFERENCE_FORM_DTO = 'catalog/reference-form.dto',
  /** Room response body */
  ROOM_FIND_DTO = 'catalog/room-find.dto',
  /** Rooms flat list API query parameters */
  ROOM_FLAT_LIST_QUERY_DTO = 'catalog/room-flat-list-query.dto',
  /** Room create/update request body */
  ROOM_FORM_DTO = 'catalog/room-form.dto',
  /** Rooms list with pagination API query parameters */
  ROOM_PAGE_QUERY_DTO = 'catalog/room-page-query.dto',
  /** Rooms list with pagination API response body */
  ROOM_PAGE_DTO = 'catalog/room-page.dto',
  /** Room partial update API request body */
  ROOM_PARTIAL_UPDATE_DTO = 'catalog/room-partial-update.dto',
  /** Required analytical features common request and response body */
  REQUIRED_ANALYTICAL_FEATURES_DTO = 'catalog/required-analytical-features.dto',
  /** 1C ERP native operation type list API filters */
  ERP_1C_OPERATION_TYPE_FILTERS_DTO = 'catalog/erp-1c-operation-type-filters.dto',
  /** 1C ERP native operation type find many API query parameters */
  ERP_1C_OPERATION_TYPE_FIND_MANY_QUERY_DTO = 'catalog/erp-1c-operation-type-find-many-query.dto',
  /** 1C ERP native operation type find one API query parameters */
  ERP_1C_OPERATION_TYPE_FIND_ONE_QUERY_DTO = 'catalog/erp-1c-operation-type-find-one-query.dto',
  /** 1C ERP native operation type response body */
  ERP_1C_OPERATION_TYPE_FIND_DTO = 'catalog/erp-1c-operation-type-find.dto',
  /** 1C ERP native operation type create and update APIs request body */
  ERP_1C_OPERATION_TYPE_FORM_DTO = 'catalog/erp-1c-operation-type-form.dto',
  /** 1C ERP native operation type find many API response body */
  ERP_1C_OPERATION_TYPE_PAGE_DTO = 'catalog/erp-1c-operation-type-page.dto',
  /** 1C ERP native operation type synchronize API query parameters */
  ERP_1C_OPERATION_TYPE_SYNC_QUERY_DTO = 'catalog/erp-1c-operation-type-sync-query.dto',
  /** Webhook response body */
  WEBHOOK_FIND_DTO = 'catalog/webhook-find.dto',
  /** Webhook create and update APIs request body */
  WEBHOOK_FORM_DTO = 'catalog/webhook-form.dto',
}
